import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { SolutionDetailsModalComponent } from "./solution-details.modal.component";
import { AssignmentDefinition, AssignmentSolutionData } from "../../assignment.interface";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class AssignmentSolutionDetailsModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = async (solution: AssignmentSolutionData, definition: AssignmentDefinition) =>
		this.modalController.create({
			id: SolutionDetailsModalComponent.modalId,
			component: SolutionDetailsModalComponent,
			cssClass: this.rideOpsUi.isV2Active()
				? "assignment-solution-details-modal assignment-solution-details-modal-v2"
				: "assignment-solution-details-modal",
			componentProps: {
				solution: solution,
				definition: definition,
			},
		});
}
